import React from 'react';
import { Redirect, Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";
import { useCanManageUserGroups } from 'components/usergroup/hooks';

export default function UsersRoute() {

    const { path } = useRouteMatch();
    const canManageUserGroups = useCanManageUserGroups();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Users canManageUserGroups={ canManageUserGroups } />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Users canManageUserGroups={ canManageUserGroups } />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Users canManageUserGroups={ canManageUserGroups } />
            </Route>
            <Route path={ `${ path }/create` } exact>
                { ({ match, history }) => canManageUserGroups
                    ? <Pages.User
                        match={ match }
                        history={ history }
                        canManageUserGroups={ canManageUserGroups } />
                    : <Redirect to={ path } /> }
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => (
                    <Pages.User
                        match={ match }
                        history={ history }
                        canManageUserGroups={ canManageUserGroups }
                        exact />
                ) }
            </Route>
        </Switch>
    );
}

